import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import { paymentVerificationRounting } from './payment-verification.routing';


@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    paymentVerificationRounting,
  ]
})
export class PaymentVerificationModule { }
